import { render, staticRenderFns } from "./EditSafeForm.vue?vue&type=template&id=6f218437&scoped=true&"
import script from "./EditSafeForm.vue?vue&type=script&lang=js&"
export * from "./EditSafeForm.vue?vue&type=script&lang=js&"
import style0 from "./EditSafeForm.vue?vue&type=style&index=0&id=6f218437&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f218437",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VForm,VIcon,VTextField,VTextarea})
